import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Frente Caixa", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Nova", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  style: {"height":"calc(100% - 60px)"},
  class: "ss-card ss-card-space ss-tela-conteudo-completo"
}
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA:")
], -1)
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-13" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "PERÍODO:")
], -1)
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_15 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_card = _resolveComponent("card")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_kanban = _resolveComponent("kanban")!
  const _component_vendas_listagem = _resolveComponent("vendas-listagem")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_venda_modal = _resolveComponent("venda-modal")!
  const _component_vendas_cancelamento_modal = _resolveComponent("vendas-cancelamento-modal")!
  const _component_carta_correcao_modal = _resolveComponent("carta-correcao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_vendas_unificar_servicos_modal = _resolveComponent("vendas-unificar-servicos-modal")!
  const _component_consulta_produtos_modal = _resolveComponent("consulta-produtos-modal")!
  const _component_frente_caixa_modal = _resolveComponent("frente-caixa-modal")!
  const _component_selecionar_abertura_caixa_modal = _resolveComponent("selecionar-abertura-caixa-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: 'VENDAS',
          tituloRecurso: _ctx.state.tituloRecurso,
          exibirAtalhosTela: false,
          exibirHistoricoTela: true,
          empresasSelecionadas: [_ctx.dadosEmpresa.codigoEmpresa]
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", {
              class: "ss-principais-acoes",
              style: _normalizeStyle(_ctx.storeSistema.state.layoutMobile ? 'margin-left: auto; margin-right: auto;' : '')
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.state.qtdSelecionadosConcluir > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Concluir Etapa",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.concluirEtapa && _ctx.concluirEtapa(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "check" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdSelecionadosRetomar > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Retornar Etapa",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.retornarEtapa && _ctx.retornarEtapa(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "rollback" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdSelecionados > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Imprimir",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "imprimir" })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdSelecionadosExcluir > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Excluir",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.excluirVendas && _ctx.excluirVendas(...args)))
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" })
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("button", {
                  type: "button",
                  style: {"width":"150px"},
                  class: "ant-btn ant-btn-secondary ss-btn-tela",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.aberturaCaixa && _ctx.aberturaCaixa(...args)))
                }, _hoisted_6, 512), [
                  [_vShow, _ctx.state.apresentarAberturaCaixa]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  style: {"width":"150px"},
                  class: "ant-btn ant-btn-primary ss-btn-tela",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.incluirVenda && _ctx.incluirVenda(...args)))
                }, _hoisted_8)
              ])
            ], 4)
          ]),
          _: 1
        }, 8, ["tituloRecurso", "empresasSelecionadas"]),
        _createVNode(_component_a_spin, {
          spinning: _ctx.state.carregandoTela,
          size: "large"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_select, {
                        value: _ctx.dadosEmpresa.codigoEmpresa,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dadosEmpresa.codigoEmpresa) = $event)),
                        options: _ctx.telaBase.empresasDisponiveis,
                        style: {"width":"100%"},
                        optionFilterProp: "label",
                        onChange: _ctx.atualizarSelecaoEmpresas,
                        disabled: true
                      }, null, 8, ["value", "options", "onChange"])
                    ]),
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
                        valor: _ctx.state.filtroPeriodo,
                        "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.filtroPeriodo) = $event)),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.periodoAlterado()))
                      }, null, 8, ["valor"]),
                      ((_ctx.state.filtroPeriodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_a_form_item, {
                                label: "Data Inicial e Final",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data_inicial_final, {
                                    dataInicialSelecionada: _ctx.state.dataInicialSelecionada,
                                    "onUpdate:dataInicialSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.dataInicialSelecionada) = $event)),
                                    dataFinalSelecionada: _ctx.state.dataFinalSelecionada,
                                    "onUpdate:dataFinalSelecionada": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.dataFinalSelecionada) = $event)),
                                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.buscarVendas()))
                                  }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_busca_geral, {
                    empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                    ordenacao: _ctx.telaBase.ordenacaoSelecionada,
                    "onUpdate:ordenacao": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                    buscaRapida: _ctx.state.buscaRapida,
                    "onUpdate:buscaRapida": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                    buscaAvancada: _ctx.state.buscaAvancada,
                    "onUpdate:buscaAvancada": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.buscaAvancada) = $event)),
                    onBuscarDados: _cache[15] || (_cache[15] = ($event: any) => (_ctx.buscarVendas(_ctx.telaBase.ordenacaoSelecionada)))
                  }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada"])
                ]),
                _: 1
              }),
              _createVNode(_component_card, { style: {"height":"calc(100vh - 225px)","margin-bottom":"0px"} }, {
                default: _withCtx(() => [
                  (_ctx.state.visualizarKanban)
                    ? (_openBlock(), _createBlock(_component_kanban, {
                        key: 0,
                        style: {"height":"calc(100vh - 270px)"},
                        switchListagem: true,
                        titulo: '',
                        colunas: _ctx.state.colunas,
                        "onUpdate:colunas": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.colunas) = $event)),
                        visualizacaoKanban: _ctx.state.visualizarKanban,
                        "onUpdate:visualizacaoKanban": [
                          _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.visualizarKanban) = $event)),
                          _ctx.buscarVendas
                        ],
                        onClickVisualizar: _ctx.clickEditar,
                        onClickSubMenu: _ctx.clickSubMenu,
                        onColunaCardAlterada: _ctx.moverCard,
                        onSelecaoCardAlterada: _ctx.selecionarCard,
                        onQtdSelecaoAlterada: _ctx.atualizarSelecionados,
                        onOrdemCardsAlterada: _ctx.atualizarOrdemCards
                      }, {
                        menus: _withCtx(() => [
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.clickEditar && _ctx.clickEditar(...args)))
                              }, "Visualizar")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.clickDuplicar && _ctx.clickDuplicar(...args)))
                              }, "Duplicar Venda")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.imprimirDetalhado(Number(_ctx.state.cardSelecionado))))
                              }, "Imprimir Venda")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.imprimirTermico(Number(_ctx.state.cardSelecionado))))
                              }, "Imprimir Térmico")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.imprimirComImagem(Number(_ctx.state.cardSelecionado))))
                              }, "Imprimir Orçamento com Imagem")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.imprimirRequisicaoMercadoria(Number(_ctx.state.cardSelecionado))))
                              }, "Imprimir Expedição de Mercadoria")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.imprimirEtiqueta(Number(_ctx.state.cardSelecionado), _ctx.ETipoEtiqueta.EtiquetaExpedicaoProduto)))
                              }, "Imprimir Etiqueta de Expedição")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.imprimirEtiqueta(Number(_ctx.state.cardSelecionado), _ctx.ETipoEtiqueta.EtiquetaExpedicaoPallet)))
                              }, "Imprimir Etiqueta de Expedição Pallet")
                            ]),
                            _: 1
                          }),
                          (_ctx.computedVisualizarNfe?.statusNotaFiscal === _ctx.EStatusNotaFiscal.Autorizada )
                            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.visualizarDFe(_ctx.state.cardSelecionado)))
                                  }, "Visualizar " + _toDisplayString(_ctx.nomeAmigavelModelo(_ctx.state.cardSelecionado)), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.computedVisualizarNfe?.statusNotaFiscal === _ctx.EStatusNotaFiscal.Cancelada )
                            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.visualizarDFe(_ctx.state.cardSelecionado)))
                                  }, "Visualizar " + _toDisplayString(_ctx.nomeAmigavelModelo(_ctx.state.cardSelecionado)) + " Cancelada", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.computedVisualizarNfe?.statusNotaFiscal === _ctx.EStatusNotaFiscal.Autorizada)
                            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 2 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.abrirCartaCorrecao(_ctx.state.cardSelecionado)))
                                  }, "Cartas de Correção")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.computedVisualizarNfe?.statusNotaFiscal === _ctx.EStatusNotaFiscal.Autorizada)
                            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 3 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.cancelarVendaSelecionada(_ctx.state.cardSelecionado)))
                                  }, "Cancelar Venda")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.verificaVisualizarNFSe(_ctx.state.cardSelecionado))
                            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 4 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.abrirUnificacaoNfse(_ctx.state.cardSelecionado)))
                                  }, "Unificar Serviços")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_menu_item, { style: {"display":"none"} }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.imprimirDetalhado(Number(_ctx.state.cardSelecionado))))
                              }, "Enviar " + _toDisplayString(_ctx.nomeAmigavelModelo(_ctx.state.cardSelecionado)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["colunas", "visualizacaoKanban", "onClickVisualizar", "onClickSubMenu", "onColunaCardAlterada", "onSelecaoCardAlterada", "onQtdSelecaoAlterada", "onOrdemCardsAlterada", "onUpdate:visualizacaoKanban"]))
                    : (_openBlock(), _createBlock(_component_vendas_listagem, {
                        key: 1,
                        vendas: _ctx.state.vendas,
                        "onUpdate:vendas": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.vendas) = $event)),
                        paginacao: _ctx.state.paginacao,
                        "onUpdate:paginacao": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.paginacao) = $event)),
                        visualizacaoKanban: _ctx.state.visualizarKanban,
                        "onUpdate:visualizacaoKanban": [
                          _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.visualizarKanban) = $event)),
                          _ctx.buscarVendas
                        ],
                        selecionados: _ctx.state.selecionados,
                        "onUpdate:selecionados": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.selecionados) = $event)),
                        onVisualizar: _ctx.editarVenda,
                        onNovoLancamento: _ctx.incluirVenda,
                        onBuscarRecebimentos: _ctx.buscarVendas,
                        onSelecaoAlterada: _ctx.atualizarTodosSelecionados,
                        onImprimir: _ctx.imprimirDetalhado,
                        onImprimirNfe: _ctx.visualizarDFe
                      }, null, 8, ["vendas", "paginacao", "visualizacaoKanban", "selecionados", "onVisualizar", "onNovoLancamento", "onBuscarRecebimentos", "onSelecaoAlterada", "onUpdate:visualizacaoKanban", "onImprimir", "onImprimirNfe"]))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["spinning"]),
        _createVNode(_component_venda_modal, {
          visivel: _ctx.state.exibirLancamento,
          "onUpdate:visivel": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
          codigoVenda: _ctx.state.vendaLancamento,
          editavel: (_ctx.etapaLancamento.statusVenda === _ctx.EStatusVenda.EmDigitacao) || (_ctx.etapaLancamento.ordem === 0) ,
          onConfirmacao: _ctx.buscarVendas,
          "duplicar-venda": _ctx.state.duplicarVenda,
          "onUpdate:duplicarVenda": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.duplicarVenda) = $event))
        }, null, 8, ["visivel", "codigoVenda", "editavel", "onConfirmacao", "duplicar-venda"]),
        _createVNode(_component_vendas_cancelamento_modal, {
          visivel: _ctx.state.exibirCancelamento,
          "onUpdate:visivel": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.exibirCancelamento) = $event)),
          venda: _ctx.state.vendaSelecionada,
          onConfirmacao: _ctx.buscarVendas
        }, null, 8, ["visivel", "venda", "onConfirmacao"]),
        _createVNode(_component_carta_correcao_modal, {
          visivel: _ctx.state.exibirCartaCorrecao,
          "onUpdate:visivel": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.exibirCartaCorrecao) = $event)),
          empresa: _ctx.dadosEmpresa.codigoEmpresa,
          venda: _ctx.state.codigoVendaSelecionada
        }, null, 8, ["visivel", "empresa", "venda"]),
        _createVNode(_component_preview_pdf, {
          arquivos: _ctx.state.arquivosPdf
        }, null, 8, ["arquivos"]),
        _createVNode(_component_vendas_unificar_servicos_modal, {
          visivel: _ctx.state.exibirUnificacaoServicos,
          "onUpdate:visivel": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.state.exibirUnificacaoServicos) = $event)),
          empresa: _ctx.dadosEmpresa.codigoEmpresa,
          venda: _ctx.state.codigoVendaSelecionada
        }, null, 8, ["visivel", "empresa", "venda"]),
        _createVNode(_component_consulta_produtos_modal, {
          visivel: _ctx.state.visualizarRastreabilidade,
          "onUpdate:visivel": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.state.visualizarRastreabilidade) = $event)),
          empresa: _ctx.dadosEmpresa.codigoEmpresa,
          preSelecao: _ctx.state.produtosSelecionados,
          tipoSelecao: 3,
          onConfirmacao: _ctx.lancarSelecaoEstoqueRastreabilidade,
          onCancelamento: _ctx.buscarVendasAposAcoes
        }, null, 8, ["visivel", "empresa", "preSelecao", "onConfirmacao", "onCancelamento"]),
        _createVNode(_component_frente_caixa_modal, {
          visivel: _ctx.state.exibirFrenteCaixa,
          "onUpdate:visivel": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.exibirFrenteCaixa) = $event)),
          dadosPadraoFrenteCaixa: _ctx.state.dadosFrenteCaixa,
          aberturaCaixa: _ctx.state.aberturaCaixa,
          "onUpdate:aberturaCaixa": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.state.aberturaCaixa) = $event))
        }, null, 8, ["visivel", "dadosPadraoFrenteCaixa", "aberturaCaixa"]),
        _createVNode(_component_selecionar_abertura_caixa_modal, {
          visivel: _ctx.state.exibirAberturaCaixa,
          "onUpdate:visivel": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.state.exibirAberturaCaixa) = $event)),
          empresa: _ctx.dadosEmpresa.codigoEmpresa,
          aberturaCaixa: _ctx.state.aberturaCaixa,
          "onUpdate:aberturaCaixa": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.aberturaCaixa) = $event)),
          onConfirmar: _ctx.abrirFrenteCaixa
        }, null, 8, ["visivel", "empresa", "aberturaCaixa", "onConfirmar"])
      ])
    ])
  ]))
}